// src/context/SurveyContext.jsx
import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
} from "react";

const SurveyContext = createContext();

export function SurveyProvider({ children }) {
  const [answers, setAnswers] = useState({});

  // key = stable id (e.g. "headcount-2025-1"), value = the value, label = friendly text for review table
  const updateAnswer = useCallback((key, value, label) => {
    setAnswers((prev) => ({
      ...prev,
      [key]: { answer: value, ...(label ? { label } : {}) },
    }));
  }, []);

  const resetAnswers = useCallback(() => setAnswers({}), []);

  const value = useMemo(
    () => ({ answers, updateAnswer, resetAnswers }),
    [answers, updateAnswer, resetAnswers]
  );

  return (
    <SurveyContext.Provider value={value}>{children}</SurveyContext.Provider>
  );
}

export function useSurvey() {
  const ctx = useContext(SurveyContext);
  if (!ctx) throw new Error("useSurvey must be used within SurveyProvider");
  return ctx;
}
